import { render, staticRenderFns } from "./CatalogMenuListing.vue?vue&type=template&id=2699576a"
import script from "./CatalogMenuListing.vue?vue&type=script&lang=js"
export * from "./CatalogMenuListing.vue?vue&type=script&lang=js"
import style0 from "./CatalogMenuListing.vue?vue&type=style&index=0&id=2699576a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports